import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

// Unregister any leftover service worker from previous deployments and clear
// its caches, then reload once so the fresh bundle is loaded without SW interference.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(regs => {
      if (!regs.length) return;
      return Promise.all(regs.map(r => r.unregister()))
        .then(() => (typeof caches !== 'undefined' ? caches.keys() : Promise.resolve([] as string[])))
        .then(keys => Promise.all(keys.map(k => caches.delete(k))))
        .then(() => window.location.reload());
    })
    .catch(() => {});
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
